/* global MtaH5 */
/* global GLOBAL_LOGGER */
import React, { Component } from 'react';
import { Carousel, WingBlank, Toast } from 'antd-mobile';
import Native from '../util/native';
import http from '../util/http';
import tools from '../util/tools';
import ReadList from '../components/readList';
import './App.css';
import part1pic from './images/1.png';
import part2pic from './images/2.png';
import part3pic from './images/3.png';
import part4pic1 from './images/4.png';
import part4pic2 from './images/5.png';
import part4pic3 from './images/6.png';
import part4pic4 from './images/7.png';
import part5pic1 from './images/8.png';
import part5pic2 from './images/9.png';
import part5pic3 from './images/10.png';
import part5pic4 from './images/11.png';
import part6pic from './images/12.png';
import part7pic1 from './images/13.png';
import part7pic2 from './images/14.png';
import part7pic3 from './images/15.png';
import part7pic4 from './images/16.jpg';
import part7pic5 from './images/17.jpg';
import part7pic6 from './images/18.jpg';
import part7pic7 from './images/19.jpg';
import morePic from './images/more.png';
import videoPic from './images/videobg.jpg';

const activityArray = [part7pic2, part7pic3, part7pic4, part7pic5, part7pic6, part7pic7];
const wxShareOptions = {
  shareData: {
    title: '一边上班，一边读一个国际MBA吧>>',
    desc: '升职加薪的机会来了，不用参加联考就可以读海外名校MBA。',
    // url: Config.CURRENT_PATH + '/index.html?shareUserId=' + Util.userInfo.userId
    imgUrl: window.location.origin + '/' + window.location.pathname.split('/')[1] + '/src/index/images/share.tiff'
  }
};
console.log(wxShareOptions);
if (tools.isWX()) {
  tools.getWXSignature(function () {
    // if (!Util.userInfo.userId || Util.userInfo.userId === 'null') {
    //   var REDIRECT_URI = Config.URL + '?r=spread/wx-login&url=' + encodeURIComponent(location.href);
    //   window.location.href = 'http://open.weixin.qq.com/connect/oauth2/authorize?appid=' +
    //     Config.APP_ID + '&redirect_uri=' + escape(REDIRECT_URI) + '&response_type=code&scope=snsapi_userinfo&state=share#wechat_redirect';
    //   return;
    // }
    //onReady();
    tools.wechatShare(wxShareOptions);
  });
} else {
  console.log('请在微信中打开');
  //onReady();
  // if (Config.IS_WEIXIN) {
  //   onReady();
  // } else {
  //   $('.page').hide();
  //   weui.alert('为保证后续服务，请在微信中打开');
  // }
}

const GET = tools.getQuery(window.location.href);
let userInfo = {
  userId: GET.userId || "",
  nickName: '匿名用户',
  avatar: '暂无头像'
};

if (Native.isInNative()) {
  userInfo = Native.getUserInfo();
  userInfo.avatar = "暂无头像";
}

// 设置native标题
Native.setNativeTitle('在职研究生');

class App extends Component {
  state = {
    userId: userInfo.userId, //用户id
    name: userInfo.nickName,   //用户名称
    avatar: userInfo.avatar,
    isInterest: false,
    videoInfo: {},
    schoolList: [
      {
        name: '美国贝翰文大学MBA',
        education: '专科',
        year: '2年',
        lesson_style: '在线学习',
        const: '¥2500',
        describe: '福布斯最佳商学院排行24名，连续十二年被评为全美100所物超所值大学之一。',
        pic_url: part4pic2
      },
      {
        name: '澳大利亚托伦斯大学MBA',
        education: '专科及以上',
        year: '2年',
        lesson_style: '在线学习',
        const: '¥2500',
        describe: '托伦斯大学是澳洲最有发展前景的大学之一，在悉尼、墨尔本等城市均有分校。',
        pic_url: part4pic3
      },
      {
        name: '西得克萨斯州A&M大学MBA',
        education: '专科及以上',
        year: '2年',
        lesson_style: '在线学习',
        const: '¥2500',
        describe: '世界著名的公立研究型大学，北美顶尖大学联盟美国大学协会和东南联盟的成员。',
        pic_url: part4pic4
      }
    ],
    certificateList: [
      {
        describe: '美国贝翰文大学毕业证书',
        pic_url: part5pic2
      },
      {
        describe: '西得克萨斯州A&M大学毕业证书',
        pic_url: part5pic3
      },
      {
        describe: '澳大利亚托伦斯大学毕业证书',
        pic_url: part5pic4
      }
    ],
    imgHeight: 'auto',
    slideIndex1: 0,
    slideIndex2: 0,
    readList: []
  }

  async componentDidMount() {
    Toast.loading('加载中...');
    const response = await http.get('?r=news/intro-video', {
      userId: this.state.userId,
      plat: 1,
      dtype: 0,
      name: this.state.name,
      avatar: this.state.avatar,
    });
    Toast.hide();
    let list;
    if (response.code === 0) {
      list = response.info.recommends
    }
    this.setState({
      readList: list || [],
      videoInfo: response.info.video,
      isInterest: response.info.liked
    })
    this.bindVideoPlay();
  }

  // 了解更多
  readMore = async (e) => {
    let tabResponse = await http.get('?r=news/cats'); //获取新闻列表页tab标签
    if (tabResponse && tabResponse.list.length > 0) {
      tabResponse.list.forEach((item, index) => {
        if (item.name === "国际硕士") {
          console.log(item.name, index)
          let storage = window.localStorage;
          storage.setItem('currentNewsChannel', JSON.stringify({
            tabIndex: index + 1,
            searchCatId: item.id
          }))
          tools.logMtaEvent('introduce_readmore_click');
          window.location.href = "newsList.html"
        }
      })
    }
  }

  //是否感兴趣
  getInterest = async (e) => {
    let isInterest = this.state.isInterest;
    let id = this.state.videoInfo.id;
    if (this.state.userId === "") {
      Toast.info('请先登录', 1);
      return;
    }
    if (isInterest === false) {
      let response = await http.post('?r=news/comment', {
        newsId: id,
        userId: this.state.userId,
        type: 2,   //点赞
        name: this.state.name,
        avatar: this.state.avatar,
      })
      if (response.code === 0) {
        tools.logMtaEvent('introduce_isinterested_click')
        this.setState({
          isInterest: true
        })
      }
    }
  }

  bindVideoPlay = () => {
    let video = document.getElementById('video-player');
    let videoMask = document.getElementsByClassName('video-mask')[0];
    let id = video.getAttribute('data-id');
    let videoId = video.getAttribute('data-newsid');
    let title = video.getAttribute("data-title");
    let type = video.getAttribute("data-type");
    let categoryId = video.getAttribute("data-categoryid");
    console.log(video);
    let isLogged = false;
    let lastTime = 0;
    if (video) {
      video.addEventListener('play', () => {
        if (!isLogged) {
          videoMask.style.display = 'none';
          const response = tools.logNews(id, this.state.userId, 2);
          isLogged = true;
          GLOBAL_LOGGER.log({
            eventTypeName: 'click',
            en: '视频播放点击',
            ep: {
              newsId: id,
              title: title,
              type: type,
              categoryId: categoryId
            }
          });
          // tools.journal('play', `news_id=${id}&title=${title}&type=${type}&categoryId=${categoryId}`);
        }
      });
      video.addEventListener('timeupdate', () => {
        let currentTime = video.currentTime;
        if (currentTime - lastTime >= 10) {
          GLOBAL_LOGGER.log({
            eventTypeName: 'loaddata',
            en: '视频播放更新',
            ep: {
              videoId: videoId,
              newsId: id,
              currentTime: currentTime,
              rateTime: 10
            }
          });
          lastTime = currentTime;
        }

      });
    }
  }

  // 数据统计
  statisticalData = (name, params) => {
    tools.logMtaEvent(name, params)
  }

  render() {
    let schoolHTML;  //院校推荐
    if (this.state.schoolList.length > 0) {
      schoolHTML = (

        <Carousel className="space-carousel"
          frameOverflow="visible"
          cellSpacing={16}
          slideWidth={0.8}
          dots={false}
          // autoplay
          // infinite
          beforeChange={(from, to) => console.log(`slide from ${from} to ${to}`)}
          afterChange={index => this.setState({ slideIndex1: index })}
        >
          {this.state.schoolList.map((item, index) => (
            <div
              key={index}
              style={{
                display: 'block',
                position: 'relative',
                // top: this.state.slideIndex1 === index ? -14 : 0,
                height: this.state.imgHeight,
              }}
            >
              <img
                src={item.pic_url}
                alt="pic"
                style={{ width: '100%', verticalAlign: 'top' }}
                onLoad={() => {
                  // fire window resize event to change height
                  window.dispatchEvent(new Event('resize'));
                  this.setState({ imgHeight: 'auto' });
                }}
              />
              <div className="school-content">
                <p className="school-name">{item.name}</p>
                <div className="school-condition">
                  <div>学历要求:{item.education}</div>
                  <div>学制:{item.year}</div>
                </div>
                <div className="school-condition">
                  <div>授课方式:{item.lesson_style}</div>
                  <div>申请费:{item.const}</div>
                </div>
                <div className="school-line"></div>
                <div className="school-des">{item.describe}</div>
              </div>
            </div>
          ))}
        </Carousel>

      )
    }

    let certificateHTML;   //学位证书
    if (this.state.certificateList.length > 0) {
      certificateHTML = (
        <Carousel
          autoplay={true}
          infinite
          beforeChange={(from, to) => console.log(`slide from ${from} to ${to}`)}
          afterChange={index => console.log('slide to', index)}
        >
          {this.state.certificateList.map((item, index) => (
            <div
              key={index}
              style={{ display: 'inline-block', width: '100%', position: 'relative', height: this.state.imgHeight }}
            >
              <img
                src={item.pic_url}
                alt="pic"
                style={{ width: '100%', verticalAlign: 'top' }}
                onLoad={() => {
                  // fire window resize event to change height
                  window.dispatchEvent(new Event('resize'));
                }}
              />
              <div className="certificate-des">{item.describe}</div>
            </div>
          ))}
        </Carousel>
      )
    }

    let activityHTML;   //线下活动
    if (activityArray.length > 0) {
      activityHTML = (
        <WingBlank>
          <Carousel className="space-carousel"
            frameOverflow="visible"
            cellSpacing={16}
            slideWidth={0.8}
            dots={false}
            beforeChange={(from, to) => console.log(`slide from ${from} to ${to}`)}
            afterChange={index => this.setState({ slideIndex2: index })}
          >
            {activityArray.map((item, index) => (
              <div
                key={index}

                style={{
                  display: 'block',
                  position: 'relative',
                  // top: this.state.slideIndex2 === index ? -10 : 0,
                  height: this.state.imgHeight,
                }}
              >
                <img
                  src={item}
                  alt="pic"
                  style={{ width: '100%', verticalAlign: 'top' }}
                  onLoad={() => {
                    // fire window resize event to change height
                    window.dispatchEvent(new Event('resize'));
                  }}
                />
              </div>
            ))}
          </Carousel>
        </WingBlank>
      )
    }

    let readHTML;  // 推荐阅读
    if (this.state.readList && this.state.readList.length > 0) {
      readHTML = (
        <div className="read-box">
          <div className="read-title"><p>推荐阅读</p></div>
          {this.state.readList.map((item, index) => (
            <ReadList key={index} data={item} />
          ))}
          <div className="read-btn" onClick={(e) => { this.readMore() }}>了解更多 ></div>
        </div>
      )
    }

    let videoHTML;  //(视频)一分钟了解国际MBA
    let isVideo = this.state.videoInfo.type === 2 ? true : false
    if (this.state.videoInfo && isVideo) {
      videoHTML = (
        <div className="video-box">
          <div className="vieo-box-title">一分钟了解国际MBA</div>
          <div className="video-box-subtitle">LEARN MORE ABOUT GLOBAL MBA</div>
          <div className="video-inner-box">
            <video
              id="video-player"
              preload="auto"
              controls
              controlsList="nodownload"
              playsInline
              poster={this.state.videoInfo.file_img_url ? this.state.videoInfo.file_img_url : videoPic}
              src={this.state.videoInfo.file_url.SD}
              data-id={this.state.videoInfo.id}
              data-newsid={this.state.videoInfo.file_id}
              data-title={this.state.videoInfo.title}
              data-type={this.state.videoInfo.type}
              data-categoryid={this.state.videoInfo.category_id}
            >
            </video>
            <div className="video-mask">
              <div className="video-number">{this.state.videoInfo.view_num ? this.state.videoInfo.view_num + '次播放' : ""}</div>
              <div className="video-time">{this.state.videoInfo.duration ? this.state.videoInfo.duration : ""}</div>
            </div>
          </div>
          <div className="video-box-des">一分钟了解什么是同等学力申硕，好毕业么？</div>
        </div>
      )
    }


    return (
      <div className="app">
        <header className="app-header">
        </header>
        {/* <Button type="primary">Hello</Button> */}
        {/* {carousle && carousle} */}
        <img src={part1pic} alt="part1" />
        {videoHTML && videoHTML}
        <img src={part2pic} alt="part2" />
        <img src={part3pic} alt="part3" />
        <section>
          <img src={part4pic1} alt="title" />
          <div className="school">
            {schoolHTML && schoolHTML}
          </div>
        </section>
        <section>
          <img src={part5pic1} alt="title" />
          <div className="certificate">
            {certificateHTML && certificateHTML}
          </div>
          <div className="note">
            <div className="note-content">在职修学分，满足毕业条件后即可获得MBA学位 学位证书与在校生完全相同，教育部认可。</div>
          </div>
        </section>
        <section>
          <img src={part6pic} alt="part6" />
          <img src={part7pic1} alt="title" />
          <div className="activity-box">
            {activityHTML && activityHTML}
          </div>
          <div className="note">
            <div className="note-content">线下活动丰富多彩，定期邀请学院教授线下授课还有各类主题分享会，增进学员间的互动与资源共享</div>
          </div>
        </section>
        {readHTML ?
          <section>
            {readHTML && readHTML}
          </section>
          :
          ""
        }
        {/* <div className="float-window" onClick={() => {this.statisticalData("introduce_float_window")}}>
          <a href="newsDetail.html?newsID=1407&plat=1">
            <img src={morePic} alt="" />
          </a>
        </div> */}
        <div className="fix-footer">
          <div className={this.state.isInterest ? "fix-footer-interested fix-footer-interested-special" : "fix-footer-interested"} onClick={(e) => { this.getInterest() }}>
            我感兴趣
          </div>
          <a href="http://www.mql-wh.com/TestExpress/evaluate-page" className="fix-footer-test" onClick={() => { this.statisticalData('introduce_test_click') }}>
            在线测试
          </a>
        </div>
      </div>
    );
  }
}

export default App;
